import React,{useState} from 'react';
import { cn } from '../../../../../../util/cn';
import { updateEmployer, updateEmployerAnnualPlan } from '../../../../../../data/employer';
import toast from 'react-hot-toast';
import ToastAlert from '../../../../../custom-ui/toast-alert/ToastAlert';

const ManageChangePlanAlert = ({
    empId,
    toggleShowSubcriptionFormModal,
    selectedPlan,
    empData = null
}: any) => {
const [loading, setLoading] = useState(false);

    function getDateAfter30Days(timestamp: {
        seconds: number;
        nanoseconds: number;
    }): string {
        // Convert seconds to milliseconds and add nanoseconds
        const date = new Date(timestamp?.seconds * 1000 + Math.floor(timestamp?.nanoseconds / 1e6));

        // Add 30 days
        const futureDate = new Date(date);
        futureDate.setDate(futureDate.getDate() + 30);

        // Format date as "30 Apr 2025"
        const options: Intl.DateTimeFormatOptions = {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        };

        return futureDate.toLocaleDateString('en-GB', options);
    }

    const handleContinuePlan = () => {
        setLoading(true)
        updateEmployerAnnualPlan(empId, {
            noOfCredits: selectedPlan,
        }).then((res) => { toggleShowSubcriptionFormModal(); toast.success(" The current plan has been updated successfully") })
     }
       


    return (
            <>
           
            <div className=' flex mt-4 flex-col justify-center items-center w-full '>
                <div className='flex mt-4 justify-center items-center w-full'>
                    <img src="/images/caution.png" className=' w-32 h-32' />
                </div>
                <div>
                    <p className='mt-4 font-extrabold  text-instant-teams-blue-Main' >YOU ARE ABOUT TO CHANGE THE PLAN</p>
                    <div className="my-4 bg-[#d2ebfc] p-3 flex flex-col justify-center items-center w-full rounded-lg">
                        <div className="grid grid-cols-[150px_1fr] gap-x-2 w-full max-w-md">
                            <p className="text-right">Current Plan  :</p>
                            <p><strong>{empData?.annualPlan?.noOfCredits}</strong> Credits per Month</p>

                            <p className="text-right">New Plan  :</p>
                            <p><strong>{selectedPlan}</strong> Credits per Month</p>

                            <p className="text-right">Plan Effective Date  :</p>
                            <p><strong>{getDateAfter30Days(empData?.lastMonthlyCreditAdded)}</strong></p>
                        </div>
                    </div>

                </div>


                <div className=' flex space-x-5 justify-center items-center w-full'>
                    <button

                        className={cn(
                            'h-[50px] mt-10 w-[210px] rounded-[70px] px-5 py-3 text-[16px] border border-instant-teams-blue-Main leading-[19.6px] font-[400] transition-all duration-200',

                        )}
                        onClick={() => toggleShowSubcriptionFormModal()}
                    >
                        Cancel
                    </button>
                    <button

                        className={cn(
                            'h-[50px] mt-10 w-[210px] rounded-[70px] px-5 py-3 text-[16px] bg-[#15415E] text-white leading-[19.6px] font-[400] transition-all duration-200',

                        )}
                        onClick={handleContinuePlan}
                    >
                      {loading?"Changing Plan ..." : "Continue"}
                    </button>

                </div>

            </div>
            <ToastAlert/>
            </>
        );
    }

    export default ManageChangePlanAlert;
